import React, { useEffect } from 'react';
//components=====================================start
import About from './components/About';
import Banner from './components/Banner';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FrictionlessSolution from './components/FrictionlessSolution';
import HowItWorks from './components/HowItWorks';
import Insights from './components/Insights';
import JoinUs from './components/JoinUs';
import Navbar from './components/Navbar';
import News from './components/News';
import OurPlatform from './components/OurPlatform';
import Teachnology from './components/Teachnology';
import Features from './components/Features';
import CarouselCookies from './components/CarouselCookies';
import TrustedAndUse from './components/TrustedAndUse';
import MenuPage from './components/MenuPage';
//components=====================================end

//gsap happens
import { gsap, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    gsap.from('.nav_content ', {
      duration: 1,
      y: '-10',
      opacity: 0.05,
      ease: Power3.easeIn,
    });
    gsap.from('.platform_container_B', {
      duration: 0.5,
      y: '10',
      opacity: 0,
      ease: Power3.easeIn,
      scrollTrigger: {
        trigger: '.platform_container_B',
        start: 'top 95%',
        end: 'bottom 40%',
        // markers: true,
        toggleActions: 'restart complete',
      },
    });
    gsap.from('.works_container', {
      duration: 0.8,
      y: '20',
      opacity: 0,
      ease: Power3.easeIn,
      scrollTrigger: {
        trigger: '.works_container',
        start: 'top 100%',
        end: 'bottom 10%',
        // markers: true,
        toggleActions: 'restart complete',
        delay: 0.8,
      },
    });
    gsap.from('.frictionless_container', {
      duration: 0.8,
      y: '20',
      opacity: 0,
      ease: Power3.easeIn,
      scrollTrigger: {
        trigger: '.frictionless_container',
        start: 'top 100%',
        end: 'bottom 60%',
        // markers: true,
        toggleActions: 'restart complete',
        delay: 0.8,
      },
    });
    gsap.from('.technology_container', {
      duration: 0.6,
      y: '20',
      opacity: 0,
      ease: Power3.easeIn,
      scrollTrigger: {
        trigger: '.technology_container',
        start: 'top 100%',
        end: 'bottom 40%',
        // markers: true,
        toggleActions: 'restart complete',
      },
    });
    // gsap.from('.features_card', {
    //   duration: 0.6,
    //   y: '30',
    //   scale: 0,
    //   ease: Power3.easeIn,
    //   scrollTrigger: {
    //     trigger: '.features_card',
    //     start: 'top 100%',
    //     end: 'bottom 40%',
    //     // markers: true,
    //     toggleActions: 'restart complete',
    //     delay: 0.5,
    //   },
    // });
    gsap.from('.news', {
      duration: 0.6,
      y: '30',
      opacity: 0.5,
      ease: Power3.easeIn,
      scrollTrigger: {
        trigger: '.news',
        start: 'top 100%',
        end: 'bottom 40%',
        // markers: true,
        toggleActions: 'restart complete',
        delay: 0.5,
      },
    });

    gsap.from('.join_container', {
      duration: 0.6,
      y: '20',
      opacity: 0,
      ease: Power3.easeIn,
      scrollTrigger: {
        trigger: '.join_container',
        start: 'top 100%',
        end: 'bottom 40%',
        // markers: true,
        toggleActions: 'restart complete',
      },
    });
  }, []);
  return (
    <>
      <section className='main_container'>
        <Navbar />
        <Banner />
        <About />
        <OurPlatform />
        <HowItWorks />
        <FrictionlessSolution />
        <Insights />
        <MenuPage />
        <Teachnology />
        <Features />
        <TrustedAndUse />
        <CarouselCookies />
        <News />
        <Contact />
        <JoinUs />
        <Footer />
      </section>
    </>
  );
}

export default App;
